import React from 'react';
import styles from './Banner.module.css';
import { useTranslation } from 'react-i18next';
import Button from '../../../../components/Buttons/Button/Button';
import Label from '../../../../components/EntToEndUI/Label/Label';
import PropTypes from 'prop-types';

const Banner = ({ serviceType, Image, showDescription = true, showList = true, ...props }) => {
  const { t } = useTranslation();
  console.log('Отрисовка баннера для сервиса:', serviceType);

  return (
    <section className={styles.sectionBanner}>
      <div className={styles.sectionBannerContainer}>
        <img src={Image} alt="metall" className={styles.backgroundImage}/>
      
        <div className={styles.contentContainer}>
          <div className={styles.textContent}>
            {/* <div className="banner-label">{t('main.banner.lable')}</div> */}
            <h1>{t(`services.${serviceType}.title`)}</h1>
            <div className="subtitle-container">
              <h4>{t(`services.${serviceType}.subtitle`)}</h4>
              {showList && t(`services.${serviceType}.list`) && 
                t(`services.${serviceType}.list`).split(';').map((item, index) => (
                  <p key={index}>- {item}</p>
                ))
              }
              {showDescription && t(`services.${serviceType}.description`) && 
                <p>{t(`services.${serviceType}.description`)}</p>
              }
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

Banner.propTypes = {
  serviceType: PropTypes.string.isRequired,
  Image: PropTypes.string.isRequired,
  showDescription: PropTypes.bool,
  showList: PropTypes.bool
};

export default Banner; 